// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PRightSquareOutlinedSvg from "@fishx/icons-svg/es/asn/PRightSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var PRightSquareOutlined = function PRightSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PRightSquareOutlinedSvg
  }));
};

PRightSquareOutlined.displayName = 'PRightSquareOutlined';
export default React.forwardRef(PRightSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PRightSquareOutlined.js
// module id = 3595
// module chunks = 0